import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { Event, PROMOTION_TYPE } from 'typings'
import {
  ReviewModal,
  ReviewModalProps,
  TextSpinner,
  useFormStateContext,
} from 'ui'
import { useTrack } from 'hooks'
import { BuyAndWin } from './BuyAndWin'
import { BuyTogether } from './BuyTogether'
import { Campaign } from './Campaign'
import { MoreForLess } from './MoreForLess'
import { ProgressiveDiscount } from './ProgressiveDiscount'
import { Regular } from './Regular'
import { SCOPE_ALERT_THRESHOLD } from './Summary/Alerts/AffectedProductsAlert'
import { useProductsPercentage } from './hooks/useProductsPercentage'
import { messages } from './messages'

export const reviewByType: { [key in PROMOTION_TYPE]?: () => JSX.Element } = {
  [PROMOTION_TYPE.BUY_TOGETHER]: BuyTogether,
  [PROMOTION_TYPE.BUY_AND_WIN]: BuyAndWin,
  [PROMOTION_TYPE.MORE_FOR_LESS]: MoreForLess,
  [PROMOTION_TYPE.PROGRESSIVE]: ProgressiveDiscount,
  [PROMOTION_TYPE.REGULAR]: Regular,
  [PROMOTION_TYPE.CAMPAIGN]: Campaign,
}

type reviewModalProps = {
  type: PROMOTION_TYPE
  open: boolean
}

const ReviewModalComponent = (props: reviewModalProps) => {
  const { type, open } = props

  if (!open) return null

  const Component = reviewByType[type]

  if (Component) return <Component />
}

export function AdminPromotionReviewModal(props: ReviewModalProps) {
  const { open } = props.state

  const { form } = useFormStateContext()
  const type = useWatch({ form, name: 'type' })

  const { loading, percentage, formattedPercentage } = useProductsPercentage({
    enabled: open,
  })

  const { $t } = useIntl()

  useTrack({
    event: Event.PRODUCT_PERCENTAGE_VIEW,
    payload: { value: percentage },
    enable: !loading && open,
    reset: !open,
  })

  const helpText =
    percentage !== undefined
      ? $t(messages.affectedProducts, {
          loading,
          spinner: <TextSpinner variant="action2" />,
          percentage: formattedPercentage,
        })
      : undefined

  const shouldHoldToSave =
    percentage !== undefined &&
    (percentage >= SCOPE_ALERT_THRESHOLD || percentage === 0)

  return (
    <ReviewModal
      helpText={helpText}
      loading={loading}
      holdToSave={shouldHoldToSave}
      {...props}
    >
      <ReviewModalComponent open={open} type={type} />
    </ReviewModal>
  )
}
